<!--
 * @Description: 项目执行人数统计5
 * @Date: 2024-01-11 14:07:13
-->
<template>
  <div class="svg-block" v-html="svg"></div>
</template>

<script setup lang="tsx">
import { OptionData } from './type';
const props = defineProps<{ optionData: OptionData }>();

const svg = `
<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1024 192.25">
  <g id="xiangguandiaoyan5" transform="translate(0 -146)">
    <rect id="矩形_1888" data-name="矩形 1888" width="1024" height="96" transform="translate(0 146)" fill="var(--theme-color-1)"/>
    <rect id="矩形_2000" data-name="矩形 2000" width="1024" height="96" transform="translate(0 242.25)" fill="#e5e5e5"/>
    <text id="当前报告总题目" transform="translate(${
      props?.optionData?.tips
        ? props?.optionData?.tips?.[0].length * 27.5
        : '84'
    } 189)" fill="#fff" font-size="16" font-weight="500" letter-spacing="0.09em"><tspan x="0" y="0">${
  props?.optionData?.tips?.[0] || '当前报告总题目'
}</tspan></text>
    <text id="_10题" data-name="10题" transform="translate(127 296.25)" font-size="16" font-weight="500" letter-spacing="0.09em"><tspan x="0" y="0">${
      props.optionData.topicSum
    }题</tspan></text>
    <text id="总参与人数_人或者机构_" data-name="总参与人数（人或者机构）" transform="translate(${
      props?.optionData?.tips
        ? props?.optionData?.tips?.[0].length * 27.5 + 318
        : '418'
    } 189)" fill="#fff" font-size="16" font-weight="500" letter-spacing="0.09em"><tspan x="0" y="0">${
  props?.optionData?.tips?.[1] || '总参与人数（人或者机构）'
}</tspan></text>
    <text id="_10个" data-name="10个" transform="translate(505 296.25)" font-size="16" font-weight="500" letter-spacing="0.09em"><tspan x="0" y="0">${
      props.optionData.userSum
    }个</tspan></text>
    <text id="分析维度" transform="translate(${
      props?.optionData?.tips
        ? props?.optionData?.tips?.[0].length * 27.5 + 720
        : '866'
    } 189)" fill="#fff" font-size="16" font-weight="500" letter-spacing="0.09em"><tspan x="0" y="0">${
  props?.optionData?.tips?.[2] || '分析维度'
}</tspan></text>
    <text id="主体分析" transform="translate(866 296.25)" font-size="16" font-weight="500" letter-spacing="0.09em"><tspan x="0" y="0">${
      props.optionData.analysisDimen
    }</tspan></text>
  </g>
</svg>
`;
</script>
<style lang="scss" scoped></style>
